export const PIN_REQUEST_LIMIT = 5;
export const PIN_TIMEOUT_DURATION_MS = 5 * 60 * 1000;
export const PIN_LENGTH = 6;
export const PIN_DIGIT_REGEX = /^[a-zA-Z0-9]+$/;
export const PIN_PASTE_REGEX = /^[a-zA-Z0-9]+$/;
